import { format, formatDistanceToNow, isSameDay } from 'date-fns'
import { sv } from 'date-fns/locale'
import type { CustomerType, EventStatus, EventType, InvitationStatus, RegistrationStatus, Role, SendStatus, SyncStatus } from '../api/types'

const opts = { locale: sv }

export const fmtDate = (iso: string) => format(new Date(iso), 'd MMM yyyy', opts)
export const fmtDateLong = (iso: string) => format(new Date(iso), 'EEEE d MMMM yyyy', opts)
export const fmtTime = (iso: string) => format(new Date(iso), 'HH.mm', opts)
export const fmtDateTime = (iso: string) => format(new Date(iso), 'd MMM yyyy HH.mm', opts)
export const fmtRelative = (iso: string) => formatDistanceToNow(new Date(iso), { addSuffix: true, locale: sv })

export function fmtEventWhen(start: string, end: string | null) {
  const s = new Date(start)
  if (!end) return `${fmtDateLong(start)} kl. ${fmtTime(start)}`
  const e = new Date(end)
  if (isSameDay(s, e)) return `${fmtDateLong(start)} kl. ${fmtTime(start)}–${fmtTime(end)}`
  return `${fmtDateTime(start)} – ${fmtDateTime(end)}`
}

export const pct = (n: number) => `${Math.round(n * 100)} %`
export const num = (n: number) => new Intl.NumberFormat('sv-SE').format(n)

/** Convert an ISO string to the value a <input type="datetime-local"> expects (local time). */
export function toLocalInput(iso: string | null | undefined) {
  if (!iso) return ''
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}
export const fromLocalInput = (v: string) => (v ? new Date(v).toISOString() : null)

export const ROLE_LABEL: Record<Role, string> = { SUPERADMIN: 'Superadmin (Solvigo)', ADMIN: 'Administratör', PROJEKTLEDARE: 'Projektledare', RADGIVARE: 'Rådgivare' }
export const isManagerRole = (r?: Role) => r === 'SUPERADMIN' || r === 'ADMIN' || r === 'PROJEKTLEDARE'
export const isAdminRole = (r?: Role) => r === 'SUPERADMIN' || r === 'ADMIN'
export const EVENT_TYPE_LABEL: Record<EventType, string> = {
  FRUKOST: 'Frukost', LUNCH: 'Lunch', MIDDAG: 'Middag', WEBINAR: 'Webinar', ANNAT: 'Annat',
}
export const EVENT_STATUS_LABEL: Record<EventStatus, string> = {
  UTKAST: 'Utkast', AKTIVT: 'Aktivt', STANGT: 'Stängt', ARKIVERAT: 'Arkiverat',
}
export const INV_STATUS_LABEL: Record<InvitationStatus, string> = {
  UTKAST: 'Utkast', SCHEMALAGD: 'Schemalagd', SKICKAS: 'Skickas…', SKICKAT: 'Skickat',
}
export const SEND_STATUS_LABEL: Record<SendStatus, string> = { KO: 'I kö', SKICKAT: 'Skickat', MISSLYCKAT: 'Misslyckat', BOUNCE: 'Studsade' }
export const REG_STATUS_LABEL: Record<RegistrationStatus, string> = { ANMALD: 'Anmäld', AVANMALD: 'Avanmäld' }
export const SYNC_STATUS_LABEL: Record<SyncStatus, string> = { OK: 'OK', VANTAR: 'Väntar', FEL: 'Fel' }
export const CUSTOMER_TYPE_LABEL: Record<CustomerType, string> = { KUND: 'Kund', PROSPEKT: 'Prospekt' }
